module.exports = __webpack_public_path__ + "img/hindi-lang.55bb3d1a.svg";